<template>
  <div>
    <base-card>
      <div class="error-container d-flex align-center">
        <div class="col-xs-8 pt_25 my_30 error-icon-container">
          <i class="error-icon far fa-exclamation-circle" />
        </div>
        <div class="error-text mt_10 col-xs-8">
          <p>Ops! Algo deu errado.</p>
          <p>
            <br />
          </p>
          <p>Confira os dados do seu cartão, ou entre em contato com seu banco.</p>
        </div>
      </div>
      <div class="mt_10 py_30 d-flex justify-center">
        <div class="col-xs-10 d-flex align-stretch error-link-container">
          <base-button text="VOLTAR PARA MINHA CONTA" @click="$emit('close')" />
        </div>
      </div>
    </base-card>
  </div>
</template>
<script>
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";

export default {
  components: { BaseButton, BaseCard }
};
</script>
<style scoped>
.error-container {
  flex-direction: column;
}

.error-container .error-icon-container {
  text-align: center;
}
.error-container .error-icon-container .error-icon {
  font-size: 80px;
  color: #df465ccc;
  opacity: 1;
}

.error-link-container .btn {
  flex: 1;
}

.error-text p {
  text-align: center;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}
</style>